// ABOUTME: "More" overflow menu for the desktop navigation bar
// ABOUTME: Shows a dropdown with tabs that didn't fit in the available width
import {
	clx,
	icon,
	Icon,
	MenuDropdown,
	Tab,
	type MenuItemConfig,
} from "@hm/fundamental"
import React from "react"

import { DROPDOWN_CLASSES } from "../types"

export interface MoreMenuProps {
	label: string
	menuItems: MenuItemConfig[]
	isOpen: boolean
	onToggle: () => void
	buttonRef: React.RefObject<HTMLButtonElement>
	menuRef: React.RefObject<HTMLDivElement>
}

export const MoreMenu: React.FC<MoreMenuProps> = ({
	label,
	menuItems,
	isOpen,
	onToggle,
	buttonRef,
	menuRef,
}) => {
	return (
		<div className="relative flex-shrink-0 ml-2">
			<button
				ref={buttonRef}
				type="button"
				className={clx(
					"cursor-pointer flex items-center gap-2 bg-transparent border-0 p-0",
					"text-foreground hover:text-foreground_faded_selected active:text-foreground_hover",
					"whitespace-nowrap flex-shrink-0",
				)}
				onClick={onToggle}
				aria-expanded={isOpen}
				aria-haspopup="true"
				data-cy="tab-More"
			>
				<Tab
					label={label}
					onSelect={() => {}}
					isActive={false}
					className="whitespace-nowrap flex-shrink-0 pointer-events-none"
				/>
				<Icon
					path={icon.mdiChevronDown}
					className={clx(
						"transition-transform",
						isOpen && "rotate-180",
					)}
				/>
			</button>

			{isOpen && (
				<div className="absolute top-full right-0 mt-2 z-[10001]">
					<div ref={menuRef} className={DROPDOWN_CLASSES}>
						<MenuDropdown items={menuItems} closeMenu={onToggle} />
					</div>
				</div>
			)}
		</div>
	)
}
